<button class="btn btn-lg btn-primary text-white mb-5" (click)="back()"><i class="fa fa-chevron-left" aria-hidden="true"></i> Zpět</button>

<p>

Zaškrtnutím tlačítka "Souhlasím se zpracováním osobních údajů" uděluji dobrovolně souhlas se zpracováním svých osobních údajů ve smyslu zákona č. 101/2000 Sb., o ochraně osobních údajů (v platném znění)

</p>
<p>

Městská nemocnice Čáslav, Jeníkovská 348, 286 01 Čáslav, IČ: 00873764 DIČ: CZ00873764 (dále jen správce) a to:

</p>
<ol>
  <li>V rozsahu jméno, příjmení, e-mailová adresa, telefonní číslo, rodné číslo, datum narození a krevní skupina.</li>
  <li>Za účelem marketingových a obchodních aktivit správce; včetně šíření obchodních sdělení týkajících se jeho výrobků či služeb.</li>
  <li>Po dobu nezbytně nutnou, maximálně však 2 roky ode dne přihlášení.</li>
  <li>Jsem si vědom toho, že tento souhlas s uchováváním, resp. se zpracováním údajů, udělený v souladu se  zákonem o ochraně osobních údajů a zákonem o některých službách informační společnosti, je dobrovolný</li>
  <li>Po celou dobu zpracovávání osobních údajů máte k nim přístup, v případě pochybností o jejich správnosti či úplnosti, máte právo na vysvětlení či jejich opravu písemnou výzvou.</li>
</ol>
